export default __webpack_public_path__ + "static/media/DNo.14-2.07b0e4c8.jpg";